import { apiClient } from './api';
import { Cover, DeckLayouts, DraftStart, DraftStatus, GuideList } from '../types/deck';

/** 이 앱은 GRK 템플릿만 쓴다(서버도 GRK 로 고정) */
const TEMPLATE = 'GRK';

type DeckOut = { layout: string; texts: Record<string, string> };
type DeckPic = { slide: number; key: string; file: File };
const deckForm = (title: string, slides: DeckOut[], images: DeckPic[]) => {
  const form = new FormData();
  form.append('deck', JSON.stringify({ template: TEMPLATE, title, slides }));
  for (const im of images) form.append(`img:${im.slide}:${im.key}`, im.file, im.file.name);
  return form;
};

const save = (blob: Blob, name: string) => {
  const a = document.createElement('a');
  a.href = URL.createObjectURL(blob);
  a.download = name;
  a.click();
  setTimeout(() => URL.revokeObjectURL(a.href), 1000);
};

/** 제안서 PPT — 본체는 서버 공용 grk-deck. 화면은 GRK_admin 「템플릿 작성」과 같다(2026-11-02) */
export const deckApi = {
  layouts: (): Promise<DeckLayouts> => apiClient.get('/deck/layouts'),
  guides: (): Promise<GuideList> => apiClient.get('/deck/guides'),
  downloadGuide: async (version: string) => save(await apiClient.getBlob(`/deck/guides/${encodeURIComponent(version)}`), `GRK_PPT_템플릿_가이드_${version}.md`),

  /** 제안서 칸 → 가이드 md 대로 AI 구성안(비동기). 그림은 표지 · 그림 칸 후보 */
  startProjectDraft: (projectId: number, opts: { title: string; slides: number; cover: Cover; guide: string; images: File[] }): Promise<DraftStart> => {
    const form = new FormData();
    form.append('title', opts.title);
    form.append('slides', String(opts.slides));
    form.append('cover', opts.cover);
    if (opts.guide) form.append('guide', opts.guide);
    for (const f of opts.images) form.append('files', f, f.name);
    return apiClient.postForm(`/deck/draft/project/${projectId}`, form);
  },
  draftStatus: (id: string): Promise<DraftStatus> => apiClient.get(`/deck/draft/${encodeURIComponent(id)}`),

  /** PPTX — 그림은 `img:<장>:<칸키>` */
  build: (title: string, slides: DeckOut[], images: DeckPic[]) => apiClient.postFormBlob('/deck/export', deckForm(title, slides, images)),
  /** 미리보기 PDF — 입력은 build 와 같다. grk-deck 이 PPTX 를 만들어 PDF 로 바꾼다 */
  preview: (title: string, slides: DeckOut[], images: DeckPic[]) => apiClient.postFormBlob('/deck/preview', deckForm(title, slides, images)),

  save,
};
